import type { TouchpointSourceType } from '@trello/cross-flow';

export type CrossFlowExperience =
  | 'freeExistingUserExperience'
  | 'newUserExperience'
  | 'onboardingUserExperience'
  | 'paidUsersExperience';

const experiencePlacements: Record<
  CrossFlowExperience,
  TouchpointSourceType[]
> = {
  newUserExperience: [
    'currentWorkspaceNavigationDrawer',
    'memberBoardsHomeScreen',
    'workspaceBoardsHomeScreen',
  ],
  freeExistingUserExperience: ['boardScreen'],
  onboardingUserExperience: ['welcomeTaskSelectionScreen'],
  paidUsersExperience: [
    'cardBackDatePicker',
    'boardDirectory',
    'boardsHomeCarouselAd',
    'boardScreen',
  ],
};

export const isSourceTargetedByExperience = (
  experience: CrossFlowExperience,
  source: TouchpointSourceType,
): boolean => {
  return experiencePlacements[experience].includes(source);
};
